import React, { forwardRef } from "react";
import { FormControl, MenuItem, Select, OutlinedInput } from "@mui/material";
import styled from "./TextInput.module.css";
import Icons from "../../../assets/icons/index";

const InputSelect = ({
  value,
  onChange,
  label,
  className,
  data,
  name,
  required,
  placeholder,
  disabled,
}) => {
  const CustomIcon = () => {
    return (
      <img src={Icons.down} alt="" className="w-[18px] h-[18px] mr-[12px]" />
    );
  };

  // const handleChange = (event) => {
  //   const selectedValue = event.target;
  //   console.log("selectedValue....", selectedValue)

  //   onChange(selectedValue);
  // };
  console.log(label, "label in input select");
  return (
    <FormControl className="w-full">
      {/* {label && (
      <div className="flex flex-row">
        <label className={styled.label} htmlFor={label}>
          {label}
          {placeholder && (
            <span className="text-gray-3 ml-[4px]">{placeholder}</span>
          )}
        </label>
        {required && <span className="text-red-0 ml-[4px] mt-[4px]">*</span>}
      </div>
      )} */}
      <Select
        displayEmpty
        value={value}
        onChange={onChange}
        name={name}
        // defaultValue={placeholder}
        disabled={disabled ? true : false}
        className={`mt-[8px] h-[48px] text-black-0 ${
          disabled ? "bg-gray-1" : ""
        }`}
        input={
          <OutlinedInput
            sx={{
              borderRadius: "4px",
              width: "270px",
            }}
          />
        }
        IconComponent={CustomIcon}
        renderValue={(selected) => {
          if (selected === "" || selected === undefined || selected === null) {
            return (
              <span className="text-gray-400">{placeholder || "Select"}</span>
            );
          }
          const selectedItem = data?.find((item) => item.id === selected);
          return selectedItem?.name || "";
        }}
      >
        <MenuItem value="" disabled>
          {placeholder || "Select"}
        </MenuItem>
        {data?.map((item, id) => (
          <MenuItem value={item.id} key={id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default InputSelect;
